module.exports = __webpack_public_path__ + "img/8.71efdfb5.jpg";